import Header from "../components/Header";
import Footer from "../components/Footer";
import HeroSlider from "../components/HeroSlider";
import TrendingHotels from "../components/TrendingHotels";
import TrendingRestaurants from "../components/TrendingRestaurants";
import { useEffect, useState } from "react";
import { fetchHotels, fetchRestaurants } from "../services/api";

function Home() {

  const [hotels, setHotels] = useState([]);
  const [restaurants, setRestaurants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userLat, setUserLat] = useState(null);
  const [userLng, setUserLng] = useState(null);

  useEffect(() => {
    // Get user's geolocation
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userLat = position.coords.latitude;
          const userLng = position.coords.longitude;
          setUserLat(userLat);
          setUserLng(userLng);

          // Fetch both hotels and restaurants
          Promise.all([
            fetchHotels({ lat: userLat, lng: userLng, page: 1 }),
            fetchRestaurants({ lat: userLat, lng: userLng, page: 1 })
          ])
            .then(([hotelRes, restaurantRes]) => {
              setHotels(hotelRes.data.data);
              setRestaurants(restaurantRes.data.data);
              setLoading(false);
            })
            .catch((err) => {
              setError("Failed to load nearby places");
              setLoading(false);
            });
        },
        (error) => {
          // If user denies geolocation, use fallback (Delhi)
          const defaultLat = 28.6139;
          const defaultLng = 77.2090;
          setUserLat(defaultLat);
          setUserLng(defaultLng);

          Promise.all([
            fetchHotels({ lat: defaultLat, lng: defaultLng, page: 1 }),
            fetchRestaurants({ lat: defaultLat, lng: defaultLng, page: 1 })
          ])
            .then(([hotelRes, restaurantRes]) => {
              setHotels(hotelRes.data.data);
              setRestaurants(restaurantRes.data.data);
              setLoading(false);
            })
            .catch((err) => {
              setError("Failed to load nearby places");
              setLoading(false);
            });
        }
      );
    } else {
      // Geolocation not supported, use default
      const defaultLat = 28.6139;
      const defaultLng = 77.2090;
      setUserLat(defaultLat);
      setUserLng(defaultLng);

      Promise.all([
        fetchHotels({ lat: defaultLat, lng: defaultLng, page: 1 }),
        fetchRestaurants({ lat: defaultLat, lng: defaultLng, page: 1 })
      ])
        .then(([hotelRes, restaurantRes]) => {
          setHotels(hotelRes.data.data);
          setRestaurants(restaurantRes.data.data);
          setLoading(false);
        })
        .catch((err) => {
          setError("Failed to load nearby places");
          setLoading(false);
        });
    }
  }, []);

  return (
    <div>

      <Header />

      <HeroSlider />

      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded text-center">
          {error}
        </div>
      )}

      {loading ? (
        <section className="bg-white py-24">
          <div className="max-w-7xl mx-auto px-4 text-center">
            <p className="text-gray-500">Loading nearby places for your location...</p>
          </div>
        </section>
      ) : (
        <>
          <TrendingHotels hotels={hotels.map(h => ({...h, userLat, userLng}))} />
          <TrendingRestaurants restaurants={restaurants.map(r => ({...r, userLat, userLng}))} />
        </>
      )}

      <section className="relative py-24 bg-gradient-to-br from-[#f3efe7] via-[#ece6da] to-[#e2d8c8]">

        <div className="max-w-7xl mx-auto px-6 text-center">

          <h2 className="text-4xl md:text-5xl font-luxury font-semibold text-luxury-dark mb-6 tracking-wide">
            Why Choose MyTrip?
          </h2>

          <div className="w-20 h-1 brand-orange-bg mx-auto mb-10 rounded-full"></div>

          <p className="text-gray-700 max-w-3xl mx-auto mb-16">
            We combine intelligent geo-discovery with curated premium listings
            to deliver an elevated hospitality experience for modern travelers.
          </p>

          <div className="grid md:grid-cols-3 gap-6">

            <div className="p-8 bg-white/80 backdrop-blur-sm rounded-xl shadow-md hover:shadow-lg transition duration-500">
              <h3 className="text-xl font-semibold mb-3 text-luxury-dark">
                Smart Discovery
              </h3>
              <p className="text-gray-600 text-sm">
                Instantly discover nearby premium hotels powered by real-time location intelligence.
              </p>
            </div>

            <div className="p-8 bg-white/80 backdrop-blur-sm rounded-xl shadow-md hover:shadow-lg transition duration-500">
              <h3 className="text-xl font-semibold mb-3 text-luxury-dark">
                Curated Luxury
              </h3>
              <p className="text-gray-600 text-sm">
                Handpicked boutique and premium stays designed for refined travelers.
              </p>
            </div>

            <div className="p-8 bg-white/80 backdrop-blur-sm rounded-xl shadow-md hover:shadow-lg transition duration-500">
              <h3 className="text-xl font-semibold mb-3 text-luxury-dark">
                Secure Platform
              </h3>
              <p className="text-gray-600 text-sm">
                Built with Symfony & React for performance, reliability and long-term scalability.
              </p>
            </div>

          </div>

        </div>

      </section>

      <Footer />

    </div>
  );
}

export default Home;
